<template>
  <div>
    <loading-indicator>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <b-card :header="$t('transactions.transaction')">
              <orders ref="orders"></orders>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </loading-indicator>
  </div>
</template>

<script>
import Orders from "@/views/transactions/Orders.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import {myAxios} from "@/services/myAxios";
import {mapStores} from "pinia";
import {useDeviceStore} from "@/stores/device";
import {useUserStore} from "@/stores/user";
import {loadAgreements, loadShips} from "@/helpers/api";
import {loadFleetTransactions} from "../../helpers/apiFleet";

export default {
  components: {Orders, LoadingIndicator},
  data() {
    return {
      interval: null,

      selected_ship: "",
      ships: []
    }
  },
  methods: {},
  watch: {
    'selected_ship'(newVal) {
      this.deviceStore.selectDevice(newVal);
      this.$refs['orders'].checkUpdates()
    }
  },
  mounted() {
    myAxios.get('/api/v1/manage/test')

    // Начальная загрузка данных
    loadShips().then(() => {
      if (this.deviceStore.isDeviceIDExist)
        this.selected_ship = this.deviceStore.getDeviceID
      else
        this.selected_ship = this.userStore.getECDISShips[0]?.value ?? ''
      this.ships = this.userStore.getECDISShips

      const userRole = this.$store.state.auth.user.role;
      if (userRole === 'distributor' || userRole === 'supervisor') {
        loadAgreements().then(() => {
          if (this.deviceStore.isDeviceIDExist)
            this.selected_ship = this.deviceStore.getDeviceID
          else
            this.selected_ship = this.userStore.getECDISShips[0]?.value ?? ''
          this.ships = this.userStore.getECDISShips
        })
      }
    })

    // Загрузка транзакций
    loadFleetTransactions(true, false)
  },
  computed: {
    ...mapStores(useDeviceStore, useUserStore),
  }

}
</script>

<style scoped>
</style>